// extracted by mini-css-extract-plugin
module.exports = {"modal-container":"ModalPropertiesLinks_modal-container___RXso","links-container":"ModalPropertiesLinks_links-container__2iqxv","content":"ModalPropertiesLinks_content__1Z_5A"};